const _CLASE9_CC = 'A'
const _6A8_DIST = 'B'
const CLASE9 = 'C'

const __dictionary = {
  [_CLASE9_CC]: {
    id: _CLASE9_CC,
    nombre: 'CLASE 6 - CENTRO COSTO - CLASE 9'
  },
  [_6A8_DIST]: {
    id: _6A8_DIST,
    nombre: '6 A 9 % DIST.'
  },
  [CLASE9]: {
    id: CLASE9,
    nombre: 'CLASE 9 EN LINEA'
  }
}

const __array = [__dictionary[_CLASE9_CC], __dictionary[_6A8_DIST], __dictionary[CLASE9]]

export default Object.freeze({
  _CLASE9_CC,
  _6A8_DIST,
  CLASE9,
  __dictionary,
  __array
})
